import { Modal, Form, Select, Input, FormInstance } from "antd";
import {
  UserAddOutlined,
  UserOutlined,
  MailOutlined,
  PhoneOutlined,
  SafetyOutlined,
  SendOutlined,
  CrownOutlined,
} from "@ant-design/icons";
import axios from "../../services/axiosInstance";
import { INVITE_MEMBER } from "../../services/apiEndPoints";
import { toastSuccess, toastError } from "../../utils/toast";

const MemberInviteComponent = (
  inviteForm: FormInstance<any>,
  isInviteModalOpen: boolean | undefined,
  setIsInviteModalOpen: (arg0: boolean) => void,
  fetchMembers: { (): Promise<void>; (): any }
) => {
  const handleInviteMember = async () => {
    try {
      const values = await inviteForm.validateFields();

      const data: Record<string, string> = {
        memberEmail: values.memberEmail,
        memberName: values.memberName,
        role: values.role,
        loginType: "email",
      };

      if (values.phoneNumber && values.phoneNumber.trim()) {
        data.phoneNumber = values.phoneNumber.trim();
      }

      await axios.post(INVITE_MEMBER, data);

      toastSuccess("Invitation sent successfully");
      inviteForm.resetFields();
      await fetchMembers();
      setIsInviteModalOpen(false);
    } catch (error: any) {
      const msg = error?.response?.data?.message;
      if (msg) {
        toastError(msg);
      }
    }
  };

  return (
    <Modal
      title={
        <>
          <UserAddOutlined style={{ marginRight: 8, color: "#1677ff" }} />
          Invite Member
        </>
      }
      open={isInviteModalOpen}
      onCancel={() => setIsInviteModalOpen(false)}
      onOk={() => handleInviteMember()}
      okText="Send Invite"
      okButtonProps={{ icon: <SendOutlined /> }}
    >
      <Form form={inviteForm} layout="vertical">
        <Form.Item
          label="Member Name"
          name="memberName"
          rules={[{ required: true, message: "Please enter member name" }]}
        >
          <Input
            prefix={<UserOutlined style={{ color: "#94a3b8" }} />}
            placeholder="John Doe"
          />
        </Form.Item>

        <Form.Item
          label="Member Email"
          name="memberEmail"
          rules={[
            { required: true, message: "Please enter email address" },
            { type: "email", message: "Please enter a valid email" },
          ]}
        >
          <Input
            prefix={<MailOutlined style={{ color: "#94a3b8" }} />}
            placeholder="john@example.com"
          />
        </Form.Item>

        <Form.Item
          label="Phone Number"
          name="phoneNumber"
          rules={[
            {
              validator: (_, value) => {
                if (!value || !value.trim()) return Promise.resolve();
                if (/^\d{10}$/.test(value.trim())) return Promise.resolve();
                return Promise.reject(new Error("Phone number must be exactly 10 digits"));
              },
            },
          ]}
        >
          <Input
            prefix={<PhoneOutlined style={{ color: "#94a3b8" }} />}
            placeholder="9876543210"
            maxLength={10}
          />
        </Form.Item>

        <Form.Item
          label="Role"
          name="role"
          initialValue="user"
          rules={[{ required: true, message: "Please select a role" }]}
        >
          <Select
            placeholder="Select role"
            suffixIcon={<SafetyOutlined style={{ color: "#94a3b8" }} />}
          >
            <Select.Option value="admin">
              <CrownOutlined style={{ marginRight: 6, color: "#8b5cf6" }} />
              Admin
            </Select.Option>
            <Select.Option value="user">
              <UserOutlined style={{ marginRight: 6, color: "#1677ff" }} />
              User
            </Select.Option>
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default MemberInviteComponent;
